import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Link, useLocation } from "react-router-dom";
import { X } from "lucide-react";
import { useAuth } from "@/lib/auth.jsx";

export default function NudgeBanner() {
  const { user } = useAuth();
  const [nudge, setNudge] = useState(null);
  const loc = useLocation();

  useEffect(() => {
    if (["/checkin", "/", "/auth", "/quiz", "/pro", "/coach"].includes(loc.pathname)) { setNudge(null); return; }
    api.get("/nudge").then(r => { if (r.data.show) setNudge(r.data); }).catch(()=>{});
  }, [loc.pathname]);

  if (!nudge) return null;

  const n = user?.name ? `${user.name}, ` : "";
  const message = nudge.kind === "first_checkin"
    ? `${n}time to log your first week. Even a zero counts. This is how we keep score.`
    : nudge.kind === "sunday"
    ? `${n}Sunday reset. Thirty seconds to log the week. Skip it and we lose momentum. Don't skip it.`
    : nudge.days_since ? `${n}${nudge.days_since} days since your last check in. Log it now. We don't wait for perfect.`
    : `${n}time for your weekly check in. Log it now. We don't wait for perfect.`;

  const dismiss = async () => {
    setNudge(null);
    try { await api.post("/nudge/dismiss"); } catch {}
  };

  return (
    <div className="max-w-6xl mx-auto px-4 pt-3" data-testid="nudge-banner">
      <div className="flex items-center gap-3 card-panel-elevated border-[#FD0F10]/40 px-3 py-2.5 sm:p-4 rounded-xl">
        <div className="text-xl sm:text-2xl shrink-0" aria-hidden>🌱</div>
        <div className="flex-1 min-w-0">
          <div className="eyebrow text-[#FD0F10] hidden sm:block">KEEP GOING</div>
          <p className="text-xs sm:text-sm text-gray-100 sm:mt-1 leading-snug">{message}</p>
        </div>
        <Link to="/checkin" className="shrink-0 hero-accent text-white text-[11px] sm:text-xs font-mono-ui uppercase tracking-wider px-3 py-2 rounded" data-testid="nudge-checkin">
          Log it
        </Link>
        <button onClick={dismiss} className="text-gray-400 hover:text-white shrink-0 p-1 -mr-1" aria-label="Dismiss" data-testid="nudge-dismiss">
          <X size={18}/>
        </button>
      </div>
    </div>
  );
}
